import { AlertMessage, ProgressIndicator } from "../framework/widgets";

import { PageEditor } from "../framework/design/page";
import { useGetPageFromUrl } from "../framework/design/page/hooks";
import { useParams } from "react-router-dom";

export const DesignPageWrapper = () => {
    const { pageId } = useParams();

    return (
        <div className="position-relative">
            {(!pageId) ? <>
                <ProgressIndicator show={true} className="mb-2" message="Please wait ..." />
            </> : <>
                <DesignPageInner pageId={pageId} />
            </>}
        </div>)
}

const DesignPageInner = ({ pageId }: { pageId: string }) => {
    const { page, pageView, isLoading, isSuccess, isError, error } = useGetPageFromUrl(pageId)

    if (isLoading || !isSuccess || !page || !pageView) {
        return <>
            <ProgressIndicator show={isLoading} className="mb-2" message="Please wait ..." />
            <AlertMessage show={isError} type="Error" message={error} />
        </>
    }

    return <>
        {(pageId === page.id) && <>
            <PageEditor page={page} pageView={pageView} />
        </>}
    </>
}